// AppLayoutHeader.jsx
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  IconButton,
  Stack,
  Button,
  useTheme,
  Divider,
} from "@mui/material";
import React, { useContext } from "react";
import PsContext from "../../../context";
import { Link, useLocation } from "react-router-dom";
import NAV from "../../nav";
import { useDialog } from "../../../context/DialogContext";
import AppLayoutDrawer from "./AppLayoutDrawer";

const AppLayoutHeader = (props) => {
  const context = useContext(PsContext);
  const { openDialog } = useDialog();
  const location = useLocation();
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleLogoutClick = () => {
    openDialog({
      title: "Confirm",
      message: "Do you want to Logout?",
      onConfirm: () => context.logout(),
    });
  };

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: theme.palette.background.paper,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          borderBottom: `1px solid ${theme.palette.divider}`,
          zIndex: 1000,
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", px: 4 }}>
          {/* Left Section */}
          <Stack direction="row" alignItems="center" spacing={3}>
            <IconButton
              edge="start"
              onClick={() => setDrawerOpen(true)}
              sx={{ display: { xs: "flex", md: "none" } }}
            >
              <MenuIcon />
            </IconButton>

            <Typography
              variant="h4"
              component={Link}
              to="/"
              sx={{
                fontWeight: 700,
                letterSpacing: "-0.5px",
                textDecoration: "none",
                background:
                  theme.palette.mode === "dark"
                    ? "linear-gradient(45deg, #fff, #aaa)"
                    : "linear-gradient(45deg, #2c3e50, #3498db)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                mr: 4,
              }}
            >
              {context.settingValue("app_name")}
            </Typography>

            {/* Desktop Navigation */}
            <Stack
              direction="row"
              spacing={1}
              sx={{ display: { xs: "none", md: "flex" } }}
            >
              {NAV.map((item, i) => {
                if (item.title === "divider")
                  return (
                    <Divider
                      key={`divider-${i}`}
                      orientation="vertical"
                      flexItem
                      sx={{ height: 32, my: "auto" }}
                    />
                  );

                return (
                  context.allowedAccess(item.module, item.action) && (
                    <Button
                      key={item.path}
                      component={Link}
                      to={item.path}
                      startIcon={<item.muiIcon />}
                      sx={{
                        minWidth: "auto",
                        px: 2,
                        color:
                          location.pathname === item.path
                            ? theme.palette.primary.main
                            : theme.palette.text.secondary,
                        fontWeight: location.pathname === item.path ? 600 : 400,
                        "&:hover": {
                          backgroundColor: theme.palette.action.hover,
                        },
                      }}
                    >
                      {item.title}
                    </Button>
                  )
                );
              })}
            </Stack>
          </Stack>

          {/* Right Section */}
          <Stack direction="row" spacing={2} alignItems="center">
            <IconButton
              size="medium"
              sx={{
                backgroundColor: theme.palette.action.hover,
                "&:hover": { backgroundColor: theme.palette.action.selected },
              }}
            >
              <NotificationsIcon />
            </IconButton>

            <IconButton
              onClick={handleLogoutClick}
              sx={{
                backgroundColor: theme.palette.action.hover,
                "&:hover": {
                  backgroundColor: theme.palette.error.light,
                  color: theme.palette.error.contrastText,
                },
              }}
            >
              <LogoutIcon />
            </IconButton>

            <IconButton sx={{ p: 0 }}>
              <AccountCircleIcon sx={{ fontSize: 32 }} />
            </IconButton>
          </Stack>
        </Toolbar>
      </AppBar>

      <AppLayoutDrawer
        open={drawerOpen}
        toggleDrawer={() => setDrawerOpen(!drawerOpen)}
      />
    </>
  );
};

export default AppLayoutHeader;
